const EVENT_ADD_PAYMENT_INFO = 'add_payment_info';
const EVENT_ADD_TO_CART = 'add_to_cart';
const itemDataArray = [];
const loadedPage = document.querySelector('[data-analytic-on-page-load]');
const isTradedIn = document.querySelector('[data-analytic-trade-in]');
const sendData = (event, items) => {
    if (!Object.keys(items).length) {
        return;
    }
    let obj = {
        event: event,
        items: items
    };
    if (isTradedIn) {
        obj['trade-in'] = isTradedIn.getAttribute('data-analytic-trade-in');
    }
    const transactionIdEl = document.querySelector('[data-analytic-transaction-id]');
    if (transactionIdEl) {
        obj.transaction_id = transactionIdEl.getAttribute('data-analytic-transaction-id');
    }
    dataLayer.push(obj);
};
const init = () => {
    document.querySelectorAll('[data-analytic-items-list]').forEach((element) => {
        const jsonObj = JSON.parse(element.getAttribute('data-analytic-json-object'));
        itemDataArray.push(jsonObj);
    });
    document.querySelectorAll('[data-analytic="add_to_cart"]').forEach((element) => {
        const item = JSON.parse(element.getAttribute('data-analytic-json-object'));
        element.addEventListener('click', () => dataLayer.push({
            'event': EVENT_ADD_TO_CART,
            'items': [item]
        }));
    });
    document.querySelectorAll('[data-analytic="remove_from_basket"]').forEach((element) => {
        const removed_item = JSON.parse(element.getAttribute('data-analytic-json-object'));
        element.addEventListener('click', () => dataLayer.push({
            'event': 'remove_from_basket',
            'items': [removed_item],
            'timeStamp': {
                'timestampMs': Date.now(),
                'isoTimestamp': new Date(Date.now()).toISOString()
            }
        }));
    });
    document.querySelectorAll('[data-analytics="add_to_cart"]').forEach((element) => {
        const item = JSON.parse(element.getAttribute('data-analytic-json-object'));
        element.addEventListener('click', () => dataLayer.push({
            'event': element.getAttribute('data-analytics'),
            'items': [item]
        }));
    });
    document.querySelectorAll('[data-analytics="remove_from_cart"]').forEach((element) => {
        const removed_item = JSON.parse(element.getAttribute('data-analytic-json-object'));
        element.addEventListener('click', () => dataLayer.push({
            'event': element.getAttribute('data-analytics'),
            'items': [removed_item],
            'timeStamp': {
                'timestampMs': Date.now(),
                'isoTimestamp': new Date(Date.now()).toISOString()
            }
        }));
    });
    window.addEventListener('load', () => {
        if (loadedPage) {
            const eventType = loadedPage.getAttribute('data-analytic-on-page-load');
            sendData(eventType, itemDataArray);
        }
    });
    document.addEventListener('showPaymentModal', () => {
        sendData(EVENT_ADD_PAYMENT_INFO, itemDataArray);
    }, false);
    document.addEventListener('DOMContentLoaded', () => {
        const promoButtons = document.querySelectorAll('.promoModalToggleExtrasAcc, .promoModalToggle, .promoPDPModalToggle');
        if (promoButtons.length > 0) {
            promoButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const targetId = button.getAttribute('data-target');
                    const modal = document.getElementById(targetId);
                    if (modal) {
                        const itemEl = modal.querySelector('.modal-content.promotionbr');
                        if (itemEl) {
                            const item = JSON.parse(itemEl.getAttribute('data-analytic-json-object'));
                            dataLayer.push({
                                event: 'view',
                                reason: 'promo viewed',
                                items: [item],
                                timeStamp: {
                                    timestampMs: Date.now(),
                                    isoTimestamp: new Date(Date.now()).toISOString()
                                }
                            });
                        }
                    }
                });
            });
        }
    });
};
export default init;
